// 节点可以同时具备多个状态，比如1和5
// currentNodeId : id
// currentNodeState: {id, state: 2, autolist: []}
export const NodeState = {
  Editing: 1,
  AutoEditing: 2,
  AutoEdited: 3,
  AutoEditedError: 4,
  TextEditing: 5,
  NormalError: 6,
};

export const localFileExt = 'flow';

export const flowPublicPath = '/api/canva/websocket';

export const FlOW_SOCKET_INFO = 'event_flow_socket_info';
export const FlOW_PROJECT_INFO = 'event_project_socket_info';

export const FlOW_TYPE = {
  NEW: 0,
  DEL: 1,
  UPDATE: 2,
};

export const UNIT_TYPE = {
  NEW: 0,
  DEL: 1,
  UPDATE: 2,
};
